<h1 i18n="@@title-Documentation" class="save-line-head">Documentazione</h1>

<h4 i18n="@@text-DocumentsDescription">
  Qualunque sia la tua tipologia di eCommerce, in questa sezione troverai tutte le
  informazioni utili per integrarti con Worldline.
</h4>

<!-- LISTA PDF -->
<div class="menu-row">
  @for (pdfHome of listPdfHome; track pdfHome) {
    <a class="menu-link">
      <mat-card class="menu-card" (click)="openPdf(pdfHome.file)">
        <div class="menu-content">
          <mat-icon svgIcon="download" class="start-icon"></mat-icon>

          <span class="label">
            @if (currentLanguage === 'it') {
              {{ pdfHome.title_version_IT }}
            }
            @if (currentLanguage === 'en') {
              {{ pdfHome.title_version_EN }}
            }
            @if (!currentLanguage) {
              {{ pdfHome.title_version_EN }}
            }
          </span>

          <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
        </div>
      </mat-card>
    </a>
  }
</div>

<!-- CTA INIZIA IL TEST -->
@if (!merchantService.accessAllowed) {
  <div class="menu-row">
    <a routerLink="transactions" class="menu-link">
      <mat-card class="menu-card" (click)="navigateToSandbox()">
        <div class="menu-content">
          <mat-icon svgIcon="gestisci" class="start-icon"></mat-icon>
          <span i18n="@@card-StartTesting" class="label">Inizia il test</span>
          <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
        </div>
      </mat-card>
    </a>
  </div>
}
